import { render } from "./DataTablePlus.vue?vue&type=template&id=82021c86&ts=true"
import script from "./DataTablePlus.vue?vue&type=script&lang=ts"
export * from "./DataTablePlus.vue?vue&type=script&lang=ts"

import "./DataTablePlus.vue?vue&type=style&index=0&id=82021c86&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/saas-base-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__